import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { IconComponent } from '@tess-core/shared';
import { MatMenuModule } from '@angular/material/menu';

import { NotificationsService } from 'src/app/notifications.service';

@Component({
  selector: 'tess-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, IconComponent, MatMenuModule],
})
export class ToolbarNotificationsComponent {
  readonly #notificationsService = inject(NotificationsService);

  readonly notifications = this.#notificationsService.notifications;
}
